// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

export const NotificationBarContainer = styled.div`
    position: sticky;
    top: 48px;
    z-index: 2001;

    width: 100%;
    padding: 10px 20px;

    color: #fff;
    font-weight: normal;
    font-size: 16px;
    text-align: center;

    background-color: #1e90ff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    strong {
        font-weight: 900;
    }
    em {
        font-style: italic;
    }
    a {
        color: #0038a8;
    }
`;
